/**
 * Venue-related enums
 */

/**
 * Theme variables used for CSS styling
 */
export const ThemeVariablesEnum = {
    COLOR_BG_PAGE: 'colorBgPage',
    COLOR_BG_BUTTON: 'colorBgButton',
    COLOR_BG_PRIMARY: 'colorBgPrimary',
    COLOR_TEXT_PRICE: 'colorTextPrice',
    COLOR_TEXT_MUTED: 'colorTextMuted',
    BORDER_MENU_ITEM: 'borderMenuItem',
    COLOR_TEXT_ACCENT: 'colorTextAccent',
    COLOR_TEXT_BUTTON: 'colorTextButton',
    COLOR_BG_SECONDARY: 'colorBgSecondary',
    COLOR_BG_BRAND_PAGE: 'colorBgBrandPage',
    COLOR_TEXT_HEADING: 'colorTextHeading',
    COLOR_TEXT_PRIMARY: 'colorTextPrimary',
    COLOR_TEXT_ITEM_BODY: 'colorTextItemBody',
    COLOR_BG_PAGE_DARKER: 'colorBgPageDarker',
    BORDER_SELECTED_ITEM: 'borderSelectedItem',
    COLOR_TEXT_SECONDARY: 'colorTextSecondary',
    COLOR_BG_BRAND_BANNER: 'colorBgBrandBanner',
    COLOR_TEXT_SUBHEADING: 'colorTextSubheading',
    BORDER_BUTTON_PRIMARY: 'borderButtonPrimary',
    COLOR_HIGHLIGHT_BORDER: 'colorHighlightBorder',
    BORDER_BOTTOM_MENU_ITEM: 'borderBottomMenuItem',
    COLOR_TEXT_BRAND_BANNER: 'colorTextBrandBanner',
    COLOR_SECONDARY_ACTIONS: 'colorSecondaryActions',
    COLOR_BG_MODAL_OVERLAY: 'colorBgModalOverlay',
    COLOR_BG_SECONDARY_TRANSPARENT: 'colorBgSecondaryTransparent',
    COLOR_BG_MODIFIER_CARD: 'colorBgModifierCard',
    COLOR_BG_SELECTED_MODIFIER_CARD: 'colorBgSelectedModifierCard',
    BOX_SHADOW_MODIFIER_CARD: 'boxShadowModifierCard',
    MENU_ITEM_WIDTH: 'menuItemWidth',
    BOX_SHADOW_MENU_ITEM: 'boxShadowMenuItem',
    BODY_TEXT_TRANSFORM: 'bodyTextTransform',
    LINE_CLAMP_MENU_ITEM: 'lineClampMenuItem',
    HEADING_TEXT_TRANSFORM: 'headingTextTransform',
    ACCENT_TEXT_TRANSFORM: 'accentTextTransform',
    MENU_LIST_ITEM_FLEX_DIRECTION: 'menuListItemFlexDirection',
    MENU_LIST_ITEM_JUSTIFY: 'menuListItemJustify',
    MENU_LIST_GRID_COLS_DESKTOP: 'menuListGridColsDesktop',
    MENU_LIST_GRID_COLS_MOBILE: 'menuListGridColsMobile',
    MENU_BG_IMAGE: 'menuBgImage',
    BUTTON_FONT: 'buttonFont',
    CLIP_PATH_BUTTON: 'clipPathButton',
    BORDER_RADIUS_BUTTON: 'borderRadiusButton',
    MODAL_BORDER: 'modalBorder',
    COLOR_BG_QUICK_ADD: 'colorBgQuickAdd',
    COLOR_TEXT_QUICK_ADD: 'colorTextQuickAdd'
};

/**
 * Font key values used in the venue module
 */
export const FontKeysEnum = {
    BODY_FONT: 'bodyFont',
    HEADING_FONT: 'headingFont',
    ACCENT_FONT: 'accentFont'
};

/**
 * Allowed keys for venue value settings
 */
export const AllowedKeysEnum = {
    LOGO: 'logo',
    ENABLED: 'enabled',
    LOGO_NAV: 'logoNav',
    PAT_IMAGE: 'patImage',
    IMAGE_SIZE: 'imageSize',
    AGE_GATED: 'ageGated',
    CART_IMAGES: 'cartImages',
    BUTTON_FONT: 'buttonFont',
    MENU_NOTICE: 'menuNotice',
    MAP_STYLE_URL: 'mapStyleUrl',
    BUSY_MESSAGE: 'busyMessage',
    DESCRIPTION: 'description',
    LARGE_IMAGES: 'largeImages',
    HEADER_IMAGE: 'headerImage',
    FAVICON_IMAGE: 'faviconImage',
    PRIMARY_COLOUR: 'primaryColour',
    MODAL_IMAGE_STYLE: 'modalImageStyle',
    MODAL_LAYOUT_STYLE: 'modalLayoutStyle',
    TABLE_SCREEN_IMAGE: 'tableScreenImage',
    ORDER_INSTRUCTIONS: 'orderInstructions',
    SHOW_CURRENCY_SYMBOL: 'showCurrencySymbol',
    ITEM_CONTENT_POSITION: 'itemContentPosition',
    SHOW_INVENTORY_QUANTITY: 'showInventoryQuantity',
    MONETARY_DISPLAY_STRATEGY: 'monetaryDisplayStrategy',
    SHOW_TABLE_SELECTION_MODAL: 'showTableSelectionModal',
    MODIFIER_STYLE: 'modifierStyle',
    MAP_MARKER_STORE_IMG: 'mapMarkerStoreImg',
    CATEGORY_NAV_IMAGES: 'categoryNavImages',
    CATEGORY_ROUTING: 'menuView',
    HEADER_STYLE: 'headerStyle',
    ALLERGEN_DISPLAY: 'allergenDisplay',
    ITEM_DESCRIPTION_LINES: 'itemDescriptionLines',
    CUSTOM_SECTIONS: 'customSections',
    MACRO_CALC: 'macroCalc'
};
